import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../store';
import { IParentStudentItem } from '../../store/focusEcoleSlice';

export interface IStatistiqueProps {
    localStudentDatasFiltered: IParentStudentItem[];
}


export default function Statistique(props: IStatistiqueProps) {

    const { localStudentDatasFiltered } = props

    const { etabs, students } = useSelector((state: IReduxState) => state.focusEcole);

    const getNombreEleveNonSouscrit = () => {
        const eleveNonSouscrit = localStudentDatasFiltered.filter(item => item.status === 0)
        return eleveNonSouscrit.length
    }

    return (
        <Box sx={{ display: "flex", gap: 2, background: "#EEEEEE", padding: 0.5, borderRadius: 1, justifyContent: "center" }}>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "yellowgreen", fontWeight: "bold", fontSize: 12 }}>{etabs?.length}</span>
                <br />
                Etablissement
            </Typography>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "#1976D2", fontWeight: "bold", fontSize: 12 }}>{students?.length}</span>
                <br />
                Effectif
            </Typography>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "red", fontWeight: "bold", fontSize: 12 }}>{localStudentDatasFiltered?.length}</span>
                <br />
                Sélectionné(s)
            </Typography>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "#FAAF00", fontWeight: "bold", fontSize: 12 }}>{getNombreEleveNonSouscrit()}</span>
                <br />
               Au Panier
            </Typography>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "green", fontWeight: "bold", fontSize: 12 }}>{localStudentDatasFiltered?.length - getNombreEleveNonSouscrit()}</span>
                <br />
                Souscrit
            </Typography>
        </Box>
    );
}
